export const removeBracesFromString = (str: string): string => {
  return str.slice(1, -1);
};
